import React from "react";
import { NavLink } from "react-router-dom";

import "./index.scss";

export default function JobItem({ job }) {
  const sliceTimeInDatetime = (datetime) => {
    return datetime.slice(datetime.indexOf(",") + 2);
  };

  return (
    <NavLink
      onClick={() => {localStorage.setItem("jobTitle", job?.title || job?.id)}}
      to={`/jobs/${job?.title}`}
      state={{details: true}}
      className="job__item"
    >
      <div className="job__item-top">
        <div className="job__item-primary">
          <div className="job__item-image">
            <img src={job?.provider_company_image} alt="provider" />
          </div>
          <div className="job__item-titles">
            <div className="job__item-id">ID# {job?.title}</div>
            <div className="job__item-provider">{job?.provider_company}</div>
          </div>
        </div>
        <div className="job__item-price">$ {job?.price}</div>
      </div>
      <div className="job__item-center">
        <div className="job__item-block_gray">
          <img src="/assets/icons/location.svg" alt="location" />
          <span>{job?.job_address}</span>
        </div>
        <div className="job__item-block_gray">
          <img src="/assets/icons/calendar.svg" alt="calendar" />
          <span>
            {job?.job_datetime} - {sliceTimeInDatetime(job?.job_endtime)}
          </span>
        </div>
      </div>
      <div className="job__item-bottom">
        <div className="job__item-person">
          <div className="job__item-person-photo">
            <img
              src={
                job?.technician_profile_image
                  ? job?.technician_profile_image
                  : "assets/icons/user-example.svg"
              }
              alt="person"
            />
          </div>
          <div className="job__item-person-texts">
            <div className="job__item-person-assign">Assigned to:</div>
            <div className="job__item-person-name">{job?.technician_name}</div>
          </div>
        </div>
        <div className={`job__item-status ${job?.job_status}`}>
          <span className={`job__item-dot ${job?.job_status}`}></span>
          <span>
            {job?.job_status === 'inprogress_site'
                ? 'On Site'
                : job?.job_status === 'inprogress_way'
                    ? 'On The Way'
                    : (job?.job_status !== 'rescheduled' && Boolean(job?.is_rescheduled))

                        ? 'Late Rescheduled'
                        : job?.job_status?.replaceAll('_', ' ')}
          </span>
        </div>
      </div>
    </NavLink>
  );
}
